module.exports = __webpack_public_path__ + "img/calming-influence.bc556721.png";